
const apiConfig = {
    //Local
   //apiUrl: 'https://localhost:7198/api/',
    //Live
    
    //DEV
    apiUrl: 'https://faman-api.solegaze.com/api/',
    
    apiKey: 'Lieda1002',
};

export default apiConfig;

